import React from "react";
import {Dialog, Pane, Avatar, Strong, Button} from "evergreen-ui";
import {getCookie} from "../util";


const SwitchClubDialog = (props) => {

    const {
        isShown,
        showDialog,
        switchClub,
    } = props;

    const userClubs = getCookie("userClubs");
    const clubId = parseInt(getCookie("clubId"));

    return (
        <Dialog
            isShown={isShown}
            title="Switch Club"
            onCloseComplete={() => showDialog(false)}
            hasFooter={false}
        >
            {userClubs ? userClubs.map((club, index) => <Pane
                marginBottom={20}
                key={index}
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
            >
                <Pane
                    display={"flex"}
                    justifyContent={"flex-start"}
                >
                    <Avatar
                        name={club["clubName"] ? club["clubName"] : "-"}
                        size={20}
                        marginRight={8}
                    />
                    <Strong>{club["clubName"]}</Strong>
                </Pane>
                {clubId === club["clubId"] ?
                    <Button
                        appearance="minimal"
                        intent="none"
                    >
                        Active
                    </Button> : <Button
                        appearance="primary"
                        onClick={() => switchClub(club)}
                    >
                        Switch
                    </Button>}
            </Pane>) : <React.Fragment/>}
        </Dialog>
    )
};

export default SwitchClubDialog;
